import { AppAreaConfig } from '@/funnels/@types'

const appAreaConfig: AppAreaConfig = {
	appArea: 'female-menopause-diet',
	options: {
		userTags: ['menopause'],
	},
	landing: {
		ids: ['loader-f-menopause-diet', 'age-menopause-f'],
		route: {
			path: '/menopause-diet-f',
			name: 'female-menopause-diet-funnel',
		},
	},
	funnel: {
		id: 'ob-female-menopause-diet',
		route: {
			path: '/menopause-diet-f/ob/:page*',
			// @ts-expect-error - Legacy: route.name не совпадает с appArea, будет исправлено позже
			name: 'female-menopause-diet-onboarding',
		},
		slug: 'female-menopause-diet',
		theme: 'light',
		locale: ['en'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-f',
	},
	upsell: {
		routeNames: ['upsell-static-subscription-activated', 'upsell-f'],
	},
	upgrade: {
		routeName: null,
	},
}

export default appAreaConfig
